<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="invoice-page" v-if="$can('Leitura', 'Painel Administração')">
    <div class="container p-2">
      <h4 class="text-center mb-5 mt-5">PAINEL ADM</h4>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Atualizar Status Proposta</h6>
            <form role="form" @submit.stop.prevent="atualizarStatusProposta">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Código</span>
                  <vs-input
                    class="w-full"
                    name="codigo"
                    id="codigo"
                    v-model="formStatus.idProposta"
                    :state="validateState('codigo')"
                    :danger="validateClass('codigo')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Status</span>
                  <v-select
                    :options="status"
                    name="Status"
                    id="Status"
                    v-model="formStatus.status"
                    :state="validateState('Status')"
                    :class="validateClass('Status')"
                  ></v-select>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button class="my-5">Atualizar</vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Ativar e Retivar Placa</h6>
            <form role="form" @submit.stop.prevent="inativarReativar">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/4 w-full">
                  <span>Placa</span>
                  <vs-input
                    v-mask="'AAA-#XX#'"
                    class="w-full"
                    name="Placa"
                    id="Placa"
                    v-model="formInativarReativar.placa"
                    :state="validateState('Placa')"
                    :danger="validateClass('Placa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <span>IdEmpresa</span>
                  <vs-input
                    class="w-full"
                    name="IdEmpresa"
                    id="IdEmpresa"
                    v-model="formInativarReativar.idEmpresa"
                    :state="validateState('IdEmpresa')"
                    :danger="validateClass('IdEmpresa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Ação</span>
                  <v-select
                    :options="acao"
                    name="Ação"
                    id="Ação"
                    v-model="formInativarReativar.acao"
                    :state="validateState('Ação')"
                    :class="validateClass('Ação')"
                  ></v-select>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-button class="my-5">Atualizar</vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Atualizar Cota</h6>
            <form role="form" @submit.stop.prevent="atualizarCota">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Código Proposta</span>
                  <vs-input
                    class="w-full"
                    name="codigo"
                    id="codigo"
                    v-model="formCota.idProposta"
                    :state="validateState('codigo')"
                    :danger="validateClass('codigo')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button class="my-5">Atualizar</vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Unificar Associado/Prospect</h6>
            <form role="form" @submit.stop.prevent="unificarAssociados">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/2 w-full">
                  <span>Cpf/CNPJ (com .)</span>
                  <vs-input
                    class="w-full"
                    name="Cpf/CNPJ"
                    id="Cpf/CNPJ"
                    v-model="formUnificacao.cpf"
                    :state="validateState('Cpf/CNPJ')"
                    :danger="validateClass('Cpf/CNPJ')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <span>IdEmpresa</span>
                  <vs-input
                    class="w-full"
                    name="IdEmpresa"
                    id="IdEmpresa"
                    v-model="formUnificacao.idEmpresa"
                    :state="validateState('IdEmpresa')"
                    :danger="validateClass('IdEmpresa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-button class="my-5">Atualizar</vs-button>
                </div>
              </div>
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/2 w-full">
                  <span>Tipo Unificação</span>
                  <ul class="leftx">
                    <li>
                      <vs-radio
                        v-model="formUnificacao.option"
                        vs-name="formUnificacao.option"
                        vs-value="ASSOCIADO"
                      >
                        Associado
                      </vs-radio>
                    </li>
                    <li>
                      <vs-radio
                        v-model="formUnificacao.option"
                        vs-name="formUnificacao.option"
                        vs-value="PROSPECT"
                      >
                        Prospect
                      </vs-radio>
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Atualizar Placa</h6>
            <form role="form" @submit.stop.prevent="atualizarPlaca">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/4 w-full">
                  <span>Placa Antiga</span>
                  <vs-input
                    v-mask="'AAA-#XX#'"
                    class="w-full"
                    name="Placa"
                    id="Placa"
                    v-model="formAtualizarPlaca.placaAntiga"
                    :state="validateState('Placa')"
                    :danger="validateClass('Placa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <span>Placa Nova</span>
                  <vs-input
                    v-mask="'AAA-#XX#'"
                    class="w-full"
                    name="Placa"
                    id="Placa"
                    v-model="formAtualizarPlaca.placaNova"
                    :state="validateState('Placa')"
                    :danger="validateClass('Placa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <span>IdEmpresa</span>
                  <vs-input
                    class="w-full"
                    name="IdEmpresa"
                    id="IdEmpresa"
                    v-model="formAtualizarPlaca.idEmpresa"
                    :state="validateState('IdEmpresa')"
                    :danger="validateClass('IdEmpresa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-button class="my-5">Atualizar</vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Resync Force</h6>
            <form role="form" @submit.stop.prevent="">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/4 w-full">
                  <span>Proposta</span>
                  <vs-input
                    class="w-full"
                    name="codigo proposta"
                    id="codigo"
                    v-model="formResync.idProposta"
                    :state="validateState('codigo proposta')"
                    :danger="validateClass('codigo proposta')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <vs-button @click="forceResync" class="my-5"
                    >Resync</vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <vs-button
                    color="dark"
                    @click="logsResync"
                    class="my-5 btn-dark"
                    >Logs
                  </vs-button>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <vs-button
                    color="dark"
                    @click="forceResyncFotos"
                    class="my-5 btn-dark"
                    >Fotos
                  </vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Cancelamentos</h6>
            <form role="form" @submit.stop.prevent="">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/4 w-full">
                  <span>Código</span>
                  <vs-input
                    class="w-full"
                    name="Código Cancelamento"
                    id="codigo"
                    v-model="formCancelamento.idCancelamento"
                    :state="validateState('Código Cancelamento')"
                    :danger="validateClass('Código Cancelamento')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <vs-button @click="finalizarCancelamento" class="my-5"
                    >Finalizar</vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button
                    color="dark"
                    @click="adicionarTermoCancelamento"
                    class="my-5 btn-dark"
                    >Adicionar Termo
                  </vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Buscar Associado SGA</h6>
            <form role="form" @submit.stop.prevent="buscarAssociadoSGA">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/2 w-full">
                  <span>Cpf/CNPJ (com .)</span>
                  <vs-input
                    class="w-full"
                    name="Cpf/CNPJ"
                    id="Cpf/CNPJ"
                    v-model="formBuscarDadosSga.cpf"
                    :state="validateState('Cpf/CNPJ')"
                    :danger="validateClass('Cpf/CNPJ')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <span>IdEmpresa</span>
                  <vs-input
                    class="w-full"
                    name="IdEmpresa"
                    id="IdEmpresa"
                    v-model="formBuscarDadosSga.idEmpresa"
                    :state="validateState('IdEmpresa')"
                    :danger="validateClass('IdEmpresa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-button class="my-5">Syncar</vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Registro Financeiro Bloqueado</h6>
            <form role="form" @submit.stop.prevent="">
              <div :class="`vx-row `">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Código Benefíciario</span>
                  <vs-input
                    class="w-full"
                    name="Código Benefíciario"
                    id="codigo"
                    v-model="formRegistroFinanceiroBlock.idAssociado"
                    :state="validateState('Código Benefíciario')"
                    :danger="validateClass('Código Benefíciario')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button
                    @click="finalizarRegistroFinanceiroBlock"
                    class="my-5"
                    >Desbloquear</vs-button
                  >
                </div>
              </div>
            </form>
          </vx-card>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Liberar Acesso Empresa</h6>
            <form role="form" @submit.stop.prevent="">
              <div :class="`vx-row `">
                <div
                  v-if="idsEmpresasUsuario.length < 1"
                  class="vx-col sm:w-1/2 w-full"
                >
                  <span>E-mail do usuário</span>
                  <vs-input
                    type="email"
                    name="formEmail"
                    id="formEmail"
                    v-model="formEmail"
                    v-validate="{ email: true }"
                    :state="validateState('formEmail')"
                    :danger="validateClass('formEmail')"
                    val-icon-danger="clear"
                    danger-text="Digite um e-mail válido"
                    @blur="buscarIdsEmpresasUsuario"
                  />
                </div>
                <div
                  v-if="idsEmpresasUsuario.length > 1"
                  class="vx-col flex gap-2 w-full"
                >
                  <div class="w-1/2">
                    <span>Empresa Login</span>
                    <v-select
                      :options="idsEmpresasUsuario"
                      name="Empresa Login"
                      id="Empresa Login"
                      v-model="formAcessoEmpresa.idUsuarioLogin"
                      v-validate="{ required: true }"
                      :state="validateState('Empresa Login')"
                      :class="validateClass('Empresa Login')"
                      danger-text="Preencha este Campo"
                    ></v-select>
                  </div>
                  <div class="w-1/2">
                    <span>Empresa à liberar</span>
                    <v-select
                      :options="idsEmpresasUsuario"
                      name="Empresa Liberada"
                      id="Empresa Liberada"
                      v-model="formAcessoEmpresa.idEmpresaLiberada"
                      v-validate="{ required: true }"
                      :state="validateState('Empresa Liberada')"
                      :class="validateClass('Empresa Liberada')"
                      danger-text="Preencha este Campo"
                    ></v-select>
                  </div>
                </div>
              </div>
              <div
                v-if="idsEmpresasUsuario.length > 1"
                class="w-full text-right mt-1"
              >
                <vs-button @click="liberaAcessoEmpresa" class="mt-5"
                  >Liberar</vs-button
                >
              </div>
            </form>
          </vx-card>
        </div>

        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">Notas de Atualização</h6>
            <div class="flex justify-evenly">
              <vs-button
                @click.stop.prevent="openAddNoteModal"
                class="my-5"
                color="primary"
                >Adicionar Nota</vs-button
              >
              <vs-button
                @click="openFetchNotesModal"
                class="my-5"
                color="primary"
                >Buscar Notas</vs-button
              >
            </div>

            <!-- Modal for adding new notes -->
            <vs-popup
              title="Notas de Atualização"
              :active.sync="showAddEditNoteModal"
            >
              <vs-card>
                <h6 class="mb-4">
                  {{ editingNote ? 'Editar Nota' : 'Adicionar Nova Nota' }}
                </h6>

                <!-- Formulário para adicionar notas -->
                <form @submit.prevent="saveNote">
                  <div class="mb-4">
                    <label for="empresas">Empresas:</label>
                    <v-select
                      :options="empresas"
                      name="Empresas"
                      id="empresas"
                      v-model="empresaSelecionada"
                      label="label"
                      track-by="id"
                      @input="buscaPerfilByEmpresa(empresaSelecionada.value)"
                    ></v-select>
                  </div>

                  <div class="mb-4">
                    <label for="setores">Perfis:</label>
                    <v-select
                      :options="perfis"
                      name="Setores"
                      id="setores"
                      v-model="perfisSelecionadosVselect"
                      :multiple="true"
                      label="label"
                      track-by="value"
                      :disabled="!perfisCarregados"
                      @input="handlePerfilSelection"
                    ></v-select>
                  </div>

                  <div class="mb-4">
                    <label for="titulo">Título:</label>
                    <vs-input
                      class="w-full"
                      name="titulo"
                      id="titulo"
                      v-model="nota.tituloNota"
                    />
                  </div>

                  <div class="mb-4">
                    <label for="assunto">Assunto:</label>
                    <vs-input
                      class="w-full"
                      name="assunto"
                      id="assunto"
                      v-model="nota.resumoNota"
                    />
                  </div>

                  <div class="mb-4">
                    <label for="descricao">Descrição:</label>
                    <vs-textarea
                      class="w-full"
                      name="descricao"
                      id="descricao"
                      v-model="nota.descricaoNota"
                    />
                  </div>

                  <div class="flex justify-evenly pt-5">
                    <vs-button
                      @click.stop.prevent="closeAddEditNoteModal"
                      class="my-5"
                      color="danger"
                    >
                      Cancelar
                    </vs-button>
                    <vs-button
                      @click.stop.prevent="saveNote"
                      class="my-5"
                      color="primary"
                    >
                      {{ editingNote ? 'Salvar Edição' : 'Salvar Nota' }}
                    </vs-button>
                  </div>
                </form>
              </vs-card>
            </vs-popup>

            <!-- Modal for fetching recent notes -->
            <vs-popup
              title="Notas de Atualização"
              id="modalListNotes"
              :active.sync="showFetchNotesModal"
            >
              <h6 class="mb-4">Notas Recentes</h6>

              <!-- Utilize v-for para iterar sobre as notas e exibi-las -->
              <vs-list>
                <vs-list-item
                  v-for="(note, index) in atualizationNotes"
                  :key="index"
                >
                  <vs-card>
                    <vs-list-content>
                      <div>
                        <p><strong>Empresa:</strong> {{ note.empresa }}</p>
                        <p><strong>ID:</strong> {{ note.idNota }}</p>
                        <p><strong>Titulo:</strong> {{ note.tituloNota }}</p>
                        <p><strong>Resumo:</strong> {{ note.resumoNota }}</p>
                        <p>
                          <strong>Descrição:</strong> {{ note.descricaoNota }}
                        </p>
                        <p>
                          <strong>Data de Criação:</strong>
                          {{ functions.formataDataISO8601(note.createdAt) }}
                        </p>
                      </div>
                    </vs-list-content>
                    <vs-list-actions class="flex justify-end gap-3">
                      <vs-button @click="excluirNota(index)" color="danger"
                        >Excluir</vs-button
                      >
                      <vs-button @click="editarNota(index)" color="primary"
                        >Editar</vs-button
                      >
                    </vs-list-actions>
                  </vs-card>
                </vs-list-item>
              </vs-list>
            </vs-popup>
          </vx-card>
        </div>
      </div>
    </div>
    <vs-popup
      :title="'Logs do Sincronismo'"
      @close="activePromptSincronismo = false"
      :active.sync="activePromptSincronismo"
    >
      <vs-collapse type="border">
        <vs-collapse-item v-for="item in logs" :key="item.idLog">
          <div slot="header">
            {{ item.etapaSinc }}
            <vs-chip v-if="item.resultado == true" color="success" class="mr-3"
              >Sucesso</vs-chip
            >
            <vs-chip v-else color="danger" class="mr-3">Erro</vs-chip>
          </div>
          <div>EndPoint: {{ item.endpoint }}</div>
          <vs-tabs>
            <vs-tab label="Requisição">
              <div class="tab-text">
                <div>
                  <vs-chip>{{
                    formataDataMilisegundos(item.dataRequisicao)
                  }}</vs-chip>
                </div>
                <br />
                <br />

                <vue-json-pretty
                  :path="'res'"
                  :data="retornaJson(item.requisicao)"
                ></vue-json-pretty>
              </div>
            </vs-tab>
            <vs-tab label="Resposta">
              <div class="tab-text">
                <div>
                  <vs-chip>{{
                    formataDataMilisegundos(item.dataResposta)
                  }}</vs-chip>
                </div>
                <br />
                <br />
                <vue-json-pretty
                  :path="'res'"
                  :data="retornaJson(item.resposta)"
                ></vue-json-pretty>
              </div>
            </vs-tab>
            <vs-tab label="Header">
              <div class="tab-text">
                <vue-json-pretty
                  :path="'res'"
                  :data="retornaJson(item.headers)"
                ></vue-json-pretty>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-collapse-item>
      </vs-collapse>
    </vs-popup>
  </div>
</template>

<script>
import service from './../../services';
import moment from 'moment';
import vSelect from 'vue-select';
import locale from './../../locale';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import functions from '../../utils/functions';
import { decryptData } from './../../services/decryptData';

export default {
  data() {
    return {
      formStatus: {},
      formInativarReativar: {},
      formCota: {},
      formUnificacao: { option: 'ASSOCIADO' },
      formAtualizarPlaca: {},
      formResync: {},
      formCancelamento: {},
      formBuscarDadosSga: {},
      formRegistroFinanceiroBlock: {},
      status: [],
      logs: [],
      activePromptSincronismo: false,
      acao: ['Inativar', 'Reativar'],
      logo: 'https://bboneapp.s3.amazonaws.com/evo-gerencial-color.png',
      formEmail: null,
      idsEmpresasUsuario: [],
      formAcessoEmpresa: {},
      showAddNoteModal: false,
      showFetchNotesModal: false,
      atualizationNotes: [],
      novaNota: {},
      functions,
      nota: {
        tituloNota: null,
        resumoNota: null,
        descricaoNota: null,
        empresa: null,
        perfisSelecionado: [],
      },
      showAddEditNoteModal: false,
      editingNote: false,
      perfis: [],
      empresaSelecionada: null,
      perfisCarregados: false,
      perfisSelecionadosVselect: [],
    };
  },
  computed: {
    todosOsPerfisSelecionados() {
      return this.perfisSelecionadosVselect.some(
        (perfil) => perfil.label === 'Todos os Perfis',
      );
    },
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    finalizarRegistroFinanceiroBlock() {
      this.$vs.loading();
      service
        .post(
          'admbptech',
          'finalizarRegistroFinanceiroBlock',
          this.formRegistroFinanceiroBlock,
        )
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Registro Financeiro Desbloqueado',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    finalizarCancelamento() {
      this.$vs.loading();
      service
        .post('admbptech', 'finalizarCancelamento', this.formCancelamento)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Status Atualizado com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    adicionarTermoCancelamento() {
      this.$vs.loading();
      service
        .post('admbptech', 'adicionarTermoCancelamento', this.formCancelamento)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Termo Adicionado com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    atualizarStatusProposta() {
      this.$vs.loading();
      service
        .post('admbptech', 'atualizarStatusProposta', this.formStatus)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Status Atualizado com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    forceResync() {
      if (this.formResync.idProposta) {
        this.$vs.loading();
        service
          .post('admbptech', 'forceResync', this.formResync)
          .then((res) => {
            this.carregando = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Resync realizado com Sucesso',
              color: 'success',
            });
          })
          .catch((e) => {
            this.carregando = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite uma Proposta',
          color: 'danger',
        });
      }
    },
    forceResyncFotos() {
      if (this.formResync.idProposta) {
        this.$vs.loading();
        service
          .post('admbptech', 'forceResyncFotos', this.formResync)
          .then((res) => {
            this.carregando = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Resync realizado com Sucesso',
              color: 'success',
            });
          })
          .catch((e) => {
            this.carregando = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite uma Proposta',
          color: 'danger',
        });
      }
    },
    logsResync() {
      if (this.formResync.idProposta) {
        this.activePromptSincronismo = true;
        var objSend = {};
        objSend.idProposta = this.formResync.idProposta;
        this.$vs.loading();
        service
          .post('admbptech', 'buscaLogsSinc', objSend)
          .then((res) => {
            this.logs = res.data;
            this.$vs.loading.close();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite uma Proposta',
          color: 'danger',
        });
      }
    },
    formataDataMilisegundos(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss:SSS');
    },
    retornaJson(str) {
      return JSON.parse(str);
    },
    atualizarCota() {
      this.$vs.loading();
      service
        .post('admbptech', 'atualizarCota', this.formCota)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Cota Atualizada com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    inativarReativar() {
      this.$vs.loading();
      service
        .post('admbptech', 'inativarReativarPlaca', this.formInativarReativar)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Placa Ativada/Reativada com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    unificarAssociados() {
      this.$vs.loading();
      service
        .post('admbptech', 'unificarAssociados', this.formUnificacao)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Associado Unificado com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    buscarAssociadoSGA() {
      this.$vs.loading();
      service
        .post('admbptech', 'buscarAssociadoSGA', this.formBuscarDadosSga)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Associado Sincado com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    atualizarPlaca() {
      this.$vs.loading();
      service
        .post('admbptech', 'atualizarPlaca', this.formAtualizarPlaca)
        .then((res) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Placa atualizada com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscarIdsEmpresasUsuario() {
      this.$validator.validate('formEmail').then((result) => {
        if (result && this.formEmail) {
          this.$vs.loading();
          service
            .post('admbptech', 'busca-empresas-por-usuario', {
              email: this.formEmail,
            })
            .then((res) => {
              res.data.forEach((element) => {
                this.idsEmpresasUsuario.push({
                  idUsuario: element['id_usuario'],
                  id: element['id_empresa'],
                  label: element['id_empresa'] + ' - ' + element['nome'],
                });
              });
              this.carregando = false;
              this.$vs.loading.close();
            })
            .catch((e) => {
              this.carregando = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
            });
        }
      });
    },
    liberaAcessoEmpresa() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (
            this.formAcessoEmpresa.idUsuarioLogin !=
            this.formAcessoEmpresa.idEmpresaLiberada
          ) {
            this.$vs.loading();
            service
              .post(
                'admbptech',
                'libera-acesso-empresa',
                this.formAcessoEmpresa,
              )
              .then((res) => {
                const msg = res.data[0].mensagem;
                this.carregando = false;
                this.$vs.loading.close();
                this.formEmail = null;
                this.idsEmpresasUsuario = [];
                this.formAcessoEmpresa = {};
                if (msg == 'Registro inserido com sucesso.') {
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: msg,
                    color: 'success',
                  });
                } else {
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: msg,
                    color: 'warning',
                  });
                }
              })
              .catch((e) => {
                this.carregando = false;
                this.$vs.loading.close();
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: e,
                  color: 'danger',
                });
              });
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Os campos não podem ser iguais',
              color: 'danger',
            });
          }
        }
      });
    },
    openAddNoteModal() {
      this.clearModalForm();
      this.showAddEditNoteModal = true;
      this.editingNote = false;
    },
    closeAddNoteModal() {
      this.showAddEditNoteModal = false;
    },
    clearModalForm() {
      this.nota = {
        tituloNota: null,
        resumoNota: null,
        descricaoNota: null,
        empresa: null,
        perfisSelecionado: [],
      };
    },
    openFetchNotesModal() {
      this.getNotificationNotes();
      this.showFetchNotesModal = true;
    },
    closeFetchNotesModal() {
      this.showFetchNotesModal = false;
    },
    getNotificationNotes() {
      try {
        const pagina = 1;
        const itensPorPagina = 100;
        const URL = `obterNotas?pagina=${pagina}&itensPorPagina=${itensPorPagina}`;
        this.$vs.loading();
        service.getAll('notas-atualizacao', {}, URL).then((res) => {
          this.atualizationNotes = res.data.map((note) => ({
            ...note,
          }));
          this.$vs.loading.close();
        });
      } catch (error) {
        this.$vs.loading.close();
        throw new Error(error);
      }
    },
    async saveNote() {
      try {
        this.$vs.loading();
        const idEmpresa = this.empresaSelecionada.value;
        const idsPerfis = this.perfisSelecionadosVselect.map(
          (perfil) => perfil.value,
        );
        const idsPerfisFiltrado = idsPerfis.join(',');
        const nota = {
          tituloNota: this.nota.tituloNota,
          resumoNota: this.nota.resumoNota,
          descricaoNota: this.nota.descricaoNota,
          empresa: idEmpresa,
          perfis: idsPerfisFiltrado,
        };
        if (this.editingNote) {
          await service.put(
            'notas-atualizacao',
            'atualizarNota/' + this.nota.idNota,
            nota,
          );
          this.showAddEditNoteModal = false;
          this.getNotificationNotes();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Nota editada com Sucesso',
            color: 'success',
          });
          this.$vs.loading.close();
          return;
        }
        this.nota.perfisSelecionado = this.perfisSelecionadosVselect;
        await service.post('notas-atualizacao', 'criarNota', nota);
        this.closeAddNoteModal();
        this.nota = {
          titulo: '',
          assunto: '',
          descricao: '',
        };
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Nota criada com Sucesso',
          color: 'success',
        });
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao criar nota',
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    async excluirNota(index) {
      try {
        this.$vs.loading();
        this.nota = { ...this.atualizationNotes[index] };
        await service.delete(
          'notas-atualizacao',
          'excluirNota/' + this.nota.idNota,
        );
        this.getNotificationNotes();
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Nota excluida com Sucesso',
          color: 'success',
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao excluir nota',
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    async editarNota(index) {
      try {
        this.nota = { ...this.atualizationNotes[index] };
        this.showAddEditNoteModal = true;
        this.empresaSelecionada = this.empresas.find(
          (empresa) => empresa.value === this.nota.empresa,
        );

        await this.buscaPerfilByEmpresa(this.empresaSelecionada.value);

        const idsPerfis = this.nota.perfis.split(',');

        if (!this.nota.perfis.trim()) {
          this.perfisSelecionadosVselect = [
            { label: 'Todos os Perfis', value: null },
          ];
        }

        if (this.nota.perfis.trim()) {
          const perfisSelecionados = this.perfis.filter((perfil) =>
            idsPerfis.includes(String(perfil.value)),
          );

          this.perfisSelecionadosVselect = perfisSelecionados;
        }

        this.editingNote = true;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Erro ao carregar a edição da nota: ${error.message}`,
          color: 'danger',
        });
      }
    },
    openAddEditNoteModal() {
      this.editingNote = false;
      this.showAddEditNoteModal = true;
    },
    closeAddEditNoteModal() {
      this.showAddEditNoteModal = false;
      this.editingNote = false;
      this.clearModalForm();
    },
    async buscaEmpresas() {
      try {
        const res = await service.post('admbptech', 'busca-empresas', {});
        this.empresas = res.data.empresas.map((setor) => {
          return {
            label: `${setor.id_empresa} - ${setor.nome}`,
            value: setor.id_empresa,
          };
        });
      } catch (error) {
        throw new Error(error);
      }
    },
    async buscaPerfilByEmpresa(idEmpresa) {
      try {
        this.$vs.loading();

        const res = await service.getAll('Perfil', {}, `list/${idEmpresa}`);

        this.perfis = res.data.map((perfil) => {
          return {
            label: perfil.nomePerfil,
            value: perfil.idPerfil,
          };
        });

        this.perfis.unshift({ label: 'Todos os Perfis', value: null });

        this.perfisCarregados = true;

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Erro ao buscar perfis por empresa: ${error.message}`,
          color: 'danger',
        });
      }
    },
    handlePerfilSelection() {
      const todosPerfisIndex = this.perfisSelecionadosVselect.findIndex(
        (perfil) => perfil.label === 'Todos os Perfis',
      );
      const hasMultipleSelections = this.perfisSelecionadosVselect.length > 1;
      const hasTodosPerfis = todosPerfisIndex !== -1;

      if (hasTodosPerfis && hasMultipleSelections) {
        this.perfisSelecionadosVselect = [
          this.perfisSelecionadosVselect[todosPerfisIndex],
        ];
        return;
      }

      const todosPerfis = this.perfisSelecionadosVselect.find(
        (perfil) => perfil.value === null,
      );

      if (todosPerfis && hasMultipleSelections) {
        this.perfisSelecionadosVselect = [todosPerfis];
      }
    },
  },
  mounted() {
    this.buscaEmpresas();
    this.buscarIdsEmpresasUsuario();
    this.$validator.localize('ptBr', locale);
    this.buscaDadosSelects(
      'domStatusCotacao',
      'status',
      'nomeStatus',
      'idStatus',
    );
  },

  components: {
    'v-select': vSelect,
    VueJsonPretty,
  },
};
</script>
<style>
#modalListNotes .vs-list--slot {
  width: 100%;
}
</style>
